import { createServerFn } from "@tanstack/react-start"
import { getSisterAppUrl } from "@/auth/lib/sso-ticket.server"

/**
 * Chrome data for in-product app switcher (Devices & SIMs ↔ Office Supplies).
 * sisterAppUrl is server-only config (SISTER_APP_URL); empty when unset.
 */
export const getAppChrome = createServerFn({ method: "GET" }).handler(
  async () => {
    let sisterAppUrl = ""
    try {
      sisterAppUrl = getSisterAppUrl() ?? ""
    } catch {
      sisterAppUrl = ""
    }
    return { sisterAppUrl }
  },
)
